var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.17 20.8899C18.354 20.6129 21.686 17.2329 21.96 12.9899C22.013 12.1599 22.013 11.2999 21.96 10.4699C21.686 6.22794 18.354 2.84994 14.17 2.57094C12.7249 2.4757 11.2751 2.4757 9.82997 2.57094C5.64597 2.84894 2.31397 6.22794 2.03997 10.4709C1.987 11.3101 1.987 12.1518 2.03997 12.9909C2.13997 14.5359 2.82297 15.9669 3.62797 17.1749C4.09497 18.0199 3.78697 19.0749 3.29997 19.9979C2.94997 20.6629 2.77397 20.9949 2.91497 21.2349C3.05497 21.4749 3.36997 21.4829 3.99897 21.4979C5.24397 21.5279 6.08297 21.1759 6.74897 20.6849C7.12597 20.4059 7.31497 20.2669 7.44497 20.2509C7.57497 20.2349 7.83197 20.3409 8.34397 20.5509C8.80397 20.7409 9.33897 20.8579 9.82897 20.8909C11.254 20.9849 12.743 20.9849 14.171 20.8909L14.17 20.8899Z",
    stroke: "#AFADC9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.538C10.5 8.688 11.172 8 12 8C12.828 8 13.5 8.689 13.5 9.538C13.5 9.845 13.413 10.13 13.262 10.37C12.814 11.084 12 11.766 12 12.615V13",
    stroke: "#AFADC9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H12.009",
    stroke: "#AFADC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.4178f67494d48e3432327f8f13404a58.svg";
export { ForwardRef as ReactComponent };